import styled from 'styled-components'

const WrapLogin = styled.div`
    min-width: 100vw;
    width: 1280px;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #313131;
    padding: 50px 60px 56px;
    box-sizing: border-box;

    .wrap-inner-login {
        display: flex;
        height: 100%;

        .login-form{
            width: 440px;
            /* height: 694px; */
            background: #FFFFFF;
            /* margin-top: 50px; */
            /* margin-left: 60px; */
            text-align: center;
            .icon-logo{
                padding-top: 65px;
                width: 100%;
            }
            .title{
                padding-top: 50px;
                font-family: "Open Sans";
                font-style: normal;
                font-weight: 600;
                font-size: 24px;
                line-height: 33px;
                color: #313131;
            }
            .note{
                color: #777777;
                font-weight: normal;
                font-size: 13px;
                line-height: 18px;
                font-family: "Open Sans";
                padding-bottom: 50px;
            }
            .form{
                display: flex;
                flex-direction: column;
                padding: 0 60px;
                .error{
                    color: #F45C5C;
                    font-size: 13px;
                    line-height: 18px;
                    height: 20px;
                }
                .btn-login{
                    margin-top: 20px;
                }
            }
            .footer{
                display: flex;
                padding: 0 60px;
                justify-content: space-between;
                margin-top: 150px;
                p{
                    font-size: 11px;
                    line-height: 15px;
                    text-align: center;
                    letter-spacing: -0.02em;
                    color: #777777;

                    &:hover {
                        cursor: pointer;
                    }
                }
            }
        }
        .bg_login{
            position: relative;
            max-width: 720px;
            /* padding-top: 50px; */
            p{
                position: absolute;
                left: 50%;
                transform: translate(-50%, 0);
                color: #FFFFFF;
                font-weight: 600;
                font-size: 30px;
                line-height: 41px;
                width: 100%;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 90%;
            }

            img {
                height: 100%;
                width: 720px;
                object-fit: cover;
            }
        }
    }
`;

export {
    WrapLogin
}